<mat-card-header>
    <mat-card-title>
        <div
            class="mat-card-title-container"
            [matTooltip]="stat.tooltip"
            matTooltipPosition="right"
        >
            {{ stat.label }}
        </div>
    </mat-card-title>
</mat-card-header>
<mat-card-content
    [ngStyle]="{ display: isContentCenterAligned ? 'flex' : 'block' }"
>
    <ng-content></ng-content>
</mat-card-content>
